'use client'

import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'
import { ReactNode, useState } from 'react'
import { Toaster } from 'sonner'
import { AdminProvider } from './AdminContext'
import { AuthProvider } from './AuthContext'
import { CompanyDataProvider } from './CompanyDataContext'
import { InboxProvider } from './InboxContext'
import { LayoutStyleProvider } from './LayoutStyleContext'

export const Providers = ({ children }: { children: ReactNode }) => {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        staleTime: 1000 * 60 * 5, // 5 minutes
                        retry: false,
                        refetchOnWindowFocus: false,
                    },
                },
            }),
    )

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider attribute="class" defaultTheme="light" forcedTheme="light">
                <TooltipProvider>
                    <LayoutStyleProvider>
                        <AuthProvider>
                            <AdminProvider>
                                <CompanyDataProvider>
                                    <InboxProvider>
                                        <Toaster />
                                        {children}
                                    </InboxProvider>
                                </CompanyDataProvider>
                            </AdminProvider>
                        </AuthProvider>
                    </LayoutStyleProvider>
                </TooltipProvider>
            </ThemeProvider>
        </QueryClientProvider>
    )
}
